import { useLocation } from 'react-router-dom';
import { translations } from "../../../constants";
import chevronRight from '../../../assets/chevron-right.svg';

function Breadcrumb() {
    const location = useLocation();

    return (
        <div className='breadcrumb-container main-container'>
            {
                location.pathname.split('/')
                    .filter(path => path !== '')
                    .map((path, index) => {
                        return (
                            <span key={index}>
                                {
                                    (index === 0 || !translations[path])?
                                        null :
                                        <img src={chevronRight} alt="chevron-right" />
                                }
                                {translations[path]}
                            </span>
                        )
                    })
            }
        </div>
    );
}

export default Breadcrumb;
